"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.DEFAULT_IMAGE = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reflux = _interopRequireDefault(require("reflux"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _ERGOComponents = _interopRequireDefault(require("./ERGOComponents.scss"));

var _core = require("@material-ui/core");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Send = _interopRequireDefault(require("@material-ui/icons/Send"));

var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _ChatHelper = require("./ChatHelper");

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _ErgoStrings = require("./ErgoStrings");

var _CordovaHelper = require("../../../../helpers/CordovaHelper");

var _Image2 = _interopRequireDefault(require("../../Image/Image"));

var _DateTimeHelper = require("../../../../helpers/DateTimeHelper");

var _ResumeSuspendListeners = require("../../../../helpers/ResumeSuspendListeners");

var _UserManagementService = _interopRequireDefault(require("../../Equizzer/services/UserManagementService"));

var _targetCss$colors, _targetCss$colors2, _targetCss$colors3, _targetCss$colors4, _targetCss$colors5, _targetCss$colors6;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var StyledTextField = (0, _core.withStyles)({
  root: {
    padding: '10px 0',
    '& label.Mui-focused': {
      color: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiFormLabel-root': {
      maxWidth: 'calc(100% - 28px)'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      },
      '&.Mui-focused fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      }
    }
  }
})(_core.TextField);
var StyledRadio = (0, _core.withStyles)({
  root: {
    '&$checked': {
      color: "".concat((_targetCss$colors = _cssConstants["default"].colors) === null || _targetCss$colors === void 0 ? void 0 : _targetCss$colors.buttonBackground, " !important")
    },
    color: (_targetCss$colors2 = _cssConstants["default"].colors) === null || _targetCss$colors2 === void 0 ? void 0 : _targetCss$colors2.buttonBackground
  }
})(_core.Radio);
var StyledButton = (0, _core.withStyles)({
  root: {
    backgroundColor: (_targetCss$colors3 = _cssConstants["default"].colors) === null || _targetCss$colors3 === void 0 ? void 0 : _targetCss$colors3.buttonBackground,
    color: (_targetCss$colors4 = _cssConstants["default"].colors) === null || _targetCss$colors4 === void 0 ? void 0 : _targetCss$colors4.buttonCaption,
    '&:hover': {
      backgroundColor: (_targetCss$colors5 = _cssConstants["default"].colors) === null || _targetCss$colors5 === void 0 ? void 0 : _targetCss$colors5.buttonBackgroundHover,
      color: (_targetCss$colors6 = _cssConstants["default"].colors) === null || _targetCss$colors6 === void 0 ? void 0 : _targetCss$colors6.buttonCaption
    }
  }
})(_Button["default"]);
var DEFAULT_IMAGE = 'data:image/jpeg;base64,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';
exports.DEFAULT_IMAGE = DEFAULT_IMAGE;

var ErgoCandidateMessageView = /*#__PURE__*/function (_Reflux$Component) {
  (0, _inherits2["default"])(ErgoCandidateMessageView, _Reflux$Component);

  var _super = _createSuper(ErgoCandidateMessageView);

  function ErgoCandidateMessageView(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErgoCandidateMessageView);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkUserData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var userData, _serverUserData$user, serverUserData, _serverUserData$user2;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA);

              if (userData.username) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _UserManagementService["default"].getUserFromAuthServer();

            case 4:
              serverUserData = _context.sent;

              if (serverUserData === null || serverUserData === void 0 ? void 0 : (_serverUserData$user = serverUserData.user) === null || _serverUserData$user === void 0 ? void 0 : _serverUserData$user.username) {
                userData.username = serverUserData === null || serverUserData === void 0 ? void 0 : (_serverUserData$user2 = serverUserData.user) === null || _serverUserData$user2 === void 0 ? void 0 : _serverUserData$user2.username;

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA, userData);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getChatRoomData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var roomInfo, _this$props$infos$str, userMessage, nowDate, oldMessages, oldMessageData, promises;

      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              console.log('getChatRoomData props.roominfo', _this.props.roomInfo);

              if (!(_this.props.roomInfo && _this.props.roomInfo.id)) {
                _context4.next = 6;
                break;
              }

              roomInfo = _this.props.roomInfo;

              _this.setState({
                roomInfo: _this.props.roomInfo
              });

              _context4.next = 24;
              break;

            case 6:
              if (_this.props.infos) {
                _context4.next = 12;
                break;
              }

              _context4.next = 9;
              return (0, _TimeoutHelper.timeout)(500);

            case 9:
              _this.getChatRoomData();

              _context4.next = 24;
              break;

            case 12:
              _context4.prev = 12;
              _context4.next = 15;
              return (0, _ChatHelper.openChatRoom)([(_this$props$infos$str = _this.props.infos.string_id) !== null && _this$props$infos$str !== void 0 ? _this$props$infos$str : _this.props.infos.id]);

            case 15:
              roomInfo = _context4.sent;

              _this.setState({
                roomInfo: roomInfo
              });

              _context4.next = 24;
              break;

            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](12);
              userMessage = _context4.t0.message;
              if (_context4.t0.message.indexOf('Subscriber not found')) userMessage = 'Der Kandidat hat die App noch nicht installiert, Sie können noch nicht mit ihm chatten.';

              _this.setState({
                chatInactive: true,
                errorMessage: userMessage
              });

            case 24:
              _context4.next = 26;
              return (0, _ChatHelper.openChatChannel)(roomInfo, _this.newMessage);

            case 26:
              nowDate = new Date().toJSON();
              _context4.next = 29;
              return (0, _ChatHelper.getAllMessagesForRoomId)(roomInfo.name, null, nowDate);

            case 29:
              oldMessages = _context4.sent;

              if (!(oldMessages && oldMessages.length > 0)) {
                _context4.next = 41;
                break;
              }

              oldMessageData = oldMessages.map(function (msg) {
                if (msg.message) return JSON.parse(msg.message);
              });
              promises = [];
              oldMessageData.forEach( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(msg) {
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          promises.push(new _promise["default"]( /*#__PURE__*/function () {
                            var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve, reject) {
                              return _regenerator["default"].wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      if (!msg.src) {
                                        _context2.next = 4;
                                        break;
                                      }

                                      _context2.next = 3;
                                      return (0, _ChatHelper.getChatMessageImageLink)(msg.src);

                                    case 3:
                                      msg.imgLink = _context2.sent;

                                    case 4:
                                      resolve();

                                    case 5:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x2, _x3) {
                              return _ref4.apply(this, arguments);
                            };
                          }()));

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context4.next = 36;
              return _promise["default"].all(promises);

            case 36:
              console.log('oldMessageData', oldMessageData);

              _this.setState({
                messages: oldMessageData
              });

              _context4.next = 40;
              return (0, _TimeoutHelper.timeout)(500);

            case 40:
              _this.scrollToLastMessage();

            case 41:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[12, 19]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "newMessage", function (message) {
      _this.addMessage(message.data);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendMessage", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var roomInfo, userData;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              roomInfo = _this.state.roomInfo;
              userData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA);

              if (!(!_this.state.currentMessage && !_this.state.imgLinkToSend)) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return", (0, _MuiAlertHelper.showAlertWithOptions)({
                title: 'Nichts zu senden',
                message: 'Bitte geben Sie eine Nachricht ein oder wählen sie ein Bild zum Versenden aus.'
              }));

            case 4:
              (0, _ChatHelper.sendMessage)(roomInfo, _this.state.currentMessage, userData.username, roomInfo.id, _this.state.imgLinkToSend);

              _this.setState({
                currentMessage: '',
                imgLinkToSend: null,
                imgLink: null,
                imgToSend: null
              }, function () {
                var el = document.getElementById('input');

                if (el) {
                  el.value = '';
                  el.blur();
                }
              });

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToLastMessage", function () {
      var el = document.getElementById('messages');

      if (el && el.scrollHeight > el.offsetHeight) {
        console.log('el', el.scrollHeight - el.offsetHeight);
        el.scrollTop = el.scrollHeight - el.offsetHeight;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addMessage", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(message) {
        var currentMessages;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                currentMessages = _this.state.messages || [];

                if (!message.src) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 4;
                return (0, _ChatHelper.getChatMessageImageLink)(message.src);

              case 4:
                message.imgLink = _context6.sent;

              case 5:
                currentMessages.push(message);

                _this.setState({
                  messages: currentMessages
                }, function () {
                  _this.scrollToLastMessage();
                });

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setMessage", function (evt) {
      var message = evt.target.value;

      _this.setState({
        currentMessage: message
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploadImage", function () {
      var galleryButton = {
        label: (0, _ErgoStrings.getString)('CHAT_FROM_GALLERY'),
        callback: function () {
          var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
            var picture, imgToSend, imgLink;
            return _regenerator["default"].wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.prev = 0;
                    _context7.next = 3;
                    return (0, _CordovaHelper.takePictureFromGallery)(800);

                  case 3:
                    picture = _context7.sent;

                    if (!picture) {
                      _context7.next = 18;
                      break;
                    }

                    _context7.prev = 5;
                    imgToSend = "data:image/jpg;base64,".concat(picture);

                    _this.setState({
                      imgUploading: true,
                      imgToSend: imgToSend
                    });

                    _context7.next = 10;
                    return (0, _ChatHelper.uploadImage)(imgToSend, _this.props.roomInfo.name);

                  case 10:
                    imgLink = _context7.sent;

                    _this.setState({
                      imgUploading: false,
                      imgLinkToSend: imgLink
                    });

                    _context7.next = 18;
                    break;

                  case 14:
                    _context7.prev = 14;
                    _context7.t0 = _context7["catch"](5);
                    console.log('chat uploadImage gallery error', _context7.t0);

                    _this.setState({
                      imgUploading: false
                    });

                  case 18:
                    _context7.next = 23;
                    break;

                  case 20:
                    _context7.prev = 20;
                    _context7.t1 = _context7["catch"](0);
                    console.log('Error taking Picture from gallery in Component Runner', _context7.t1);

                  case 23:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, null, [[0, 20], [5, 14]]);
          }));

          function callback() {
            return _callback.apply(this, arguments);
          }

          return callback;
        }()
      };
      var cameraButton = {
        label: (0, _ErgoStrings.getString)('CHAT_FROM_CAMERA'),
        callback: function () {
          var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
            var picture, imgToSend, imgLink;
            return _regenerator["default"].wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.prev = 0;
                    _context8.next = 3;
                    return (0, _CordovaHelper.takePictureWithCamera)(800);

                  case 3:
                    picture = _context8.sent;

                    if (!picture) {
                      _context8.next = 18;
                      break;
                    }

                    _context8.prev = 5;
                    imgToSend = "data:image/jpg;base64,".concat(picture);

                    _this.setState({
                      imgUploading: true,
                      imgToSend: imgToSend
                    });

                    _context8.next = 10;
                    return (0, _ChatHelper.uploadImage)(imgToSend, _this.props.roomInfo.name);

                  case 10:
                    imgLink = _context8.sent;

                    _this.setState({
                      imgUploading: false,
                      imgLinkToSend: imgLink
                    });

                    _context8.next = 18;
                    break;

                  case 14:
                    _context8.prev = 14;
                    _context8.t0 = _context8["catch"](5);
                    console.log('chat uploadImage camera error', _context8.t0);

                    _this.setState({
                      imgUploading: false
                    });

                  case 18:
                    _context8.next = 23;
                    break;

                  case 20:
                    _context8.prev = 20;
                    _context8.t1 = _context8["catch"](0);
                    console.log('Error taking Picture in ergo chat', _context8.t1);

                  case 23:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, null, [[0, 20], [5, 14]]);
          }));

          function callback() {
            return _callback2.apply(this, arguments);
          }

          return callback;
        }()
      };
      (0, _MuiAlertHelper.showAlertWithOptions)({
        html: (0, _ErgoStrings.getString)('CHAT_CHOOSE_IMAGE_SOURCE_TEXT'),
        title: (0, _ErgoStrings.getString)('CHAT_CHOOSE_IMAGE_SOURCE_TITLE'),
        centeredContent: true,
        buttons: [cameraButton, galleryButton]
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMessages", function () {
      var messages = _this.state.messages;

      var userData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA);

      if (messages && messages.length > 0) {
        return messages.map(function (singleMessage) {
          var date = new Date(singleMessage.senderTime);
          var dateStr = (0, _DateTimeHelper.formatDateAndTime)(date);
          console.log('render message', singleMessage);
          var isMe = (userData.username || userData.candidateId) === singleMessage.sender;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: isMe ? _ERGOComponents["default"].singleMessageFromMe : _ERGOComponents["default"].singleMessageFromOther
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _ERGOComponents["default"].messageDate
          }, "".concat(dateStr.dateString, " - ").concat(dateStr.timeString)), singleMessage.imgLink ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Image2["default"], {
            alt: "message image",
            src: singleMessage.imgLink
          }), /*#__PURE__*/_react["default"].createElement("div", {
            dangerouslySetInnerHTML: {
              __html: singleMessage.caption
            }
          })) : /*#__PURE__*/_react["default"].createElement("div", {
            dangerouslySetInnerHTML: {
              __html: singleMessage.html
            }
          }));
        });
      }
    });
    _this.state = {
      candidateInfos: null,
      messages: [],
      roomInfos: null,
      currentMessage: null,
      roomInfo: null,
      imgUploading: false,
      imgToSend: null,
      imgLinkToSend: null,
      chatInactive: false,
      errorMessage: ''
    };
    return _this;
  }

  (0, _createClass2["default"])(ErgoCandidateMessageView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      console.log('messageview did mount', this.props.roomInfo);
      this.getChatRoomData();
      this.checkUserData();
      (0, _ResumeSuspendListeners.addOnResumeListener)(function () {
        return _this2.getChatRoomData();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      (0, _ResumeSuspendListeners.removeOnResumeListener)(function () {
        return _this3.getChatRoomData();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (this.state.chatInactive) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _ERGOComponents["default"].chatContainer
        }, /*#__PURE__*/_react["default"].createElement(_core.Card, {
          className: _ERGOComponents["default"].messageCard
        }, /*#__PURE__*/_react["default"].createElement("div", null, this.state.errorMessage)));
      }

      if (!this.state.roomInfo) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var chatPartnerName;

      if (this.props.infos) {
        var _this$props$infos, _this$props$infos2;

        chatPartnerName = ((_this$props$infos = this.props.infos) === null || _this$props$infos === void 0 ? void 0 : _this$props$infos.firstname) + ' ' + ((_this$props$infos2 = this.props.infos) === null || _this$props$infos2 === void 0 ? void 0 : _this$props$infos2.lastname);
      } else if (this.props.roomInfo) {
        var _userData$additionalD, _this$props$roomInfo, _this$props$roomInfo$;

        var userData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA);

        var recruiterId = userData.recruiterId || (userData === null || userData === void 0 ? void 0 : (_userData$additionalD = userData.additionalData) === null || _userData$additionalD === void 0 ? void 0 : _userData$additionalD.recruiterId);
        var chatPartner = (_this$props$roomInfo = this.props.roomInfo) === null || _this$props$roomInfo === void 0 ? void 0 : (_this$props$roomInfo$ = _this$props$roomInfo._subscriptions) === null || _this$props$roomInfo$ === void 0 ? void 0 : _this$props$roomInfo$.find(function (user) {
          console.log('chatPartnerName', userData, user);
          return user.username === recruiterId;
        });

        if (chatPartner) {
          chatPartnerName = chatPartner.nickname;
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].chatContainer
      }, /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _ERGOComponents["default"].messageCard
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].chatTitle
      }, "Chat mit ".concat(chatPartnerName)), /*#__PURE__*/_react["default"].createElement("div", {
        id: 'messages',
        className: _ERGOComponents["default"].oldMessages
      }, this.renderMessages()), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].sendContainer
      }, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].input
      }, this.state.imgToSend ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].imageContainer
      }, /*#__PURE__*/_react["default"].createElement(_Image2["default"], {
        alt: "message image",
        src: this.state.imgToSend
      }), /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        className: _ERGOComponents["default"].closeIcon,
        onClick: function onClick() {
          _this4.setState({
            imgToSend: null
          });
        }
      })) : null, /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Nachricht',
        id: 'input',
        value: this.state.currentMessage,
        onChange: this.setMessage,
        fullWidth: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].iconContainer
      }, this.state.imgUploading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        className: _ERGOComponents["default"].sendIcon
      }) : /*#__PURE__*/_react["default"].createElement(_Send["default"], {
        onClick: function onClick() {
          return _this4.sendMessage();
        },
        className: _ERGOComponents["default"].sendIcon
      }), _config["default"].allowErgoChatImages && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "image icon",
        onClick: function onClick() {
          return _this4.uploadImage();
        },
        className: _ERGOComponents["default"].imageIcon
      })))));
    }
  }]);
  return ErgoCandidateMessageView;
}(_reflux["default"].Component);

exports["default"] = ErgoCandidateMessageView;
ErgoCandidateMessageView.propTypes = {
  infos: _propTypes["default"].object,
  triggerCandidateReload: _propTypes["default"].func
};